import { LuClock } from "react-icons/lu";
import { getRefundAdminStage } from "../../../../data/flight/order/getRefundAdminGuidance";

function RefundConfirmationRequestProgress({ data }) {
  const steps = [
    "Request received",
    "Review",
    "Quote",
    "Agent confirmation",
    "Airline submission",
    "Wallet credit",
    "Completed",
  ];

  const stage = getRefundAdminStage(data);
  const activeByStage = {
    needs_review: 2,
    needs_quote: 3,
    needs_manual_review: 3,
    auto_processing: 3,
    awaiting_agent: 4,
    quote_expired: 3,
    needs_airline_submit: 5,
    send_failed: 5,
    awaiting_supplier: 5,
    needs_reimburse: 6,
    settlement_failed: 6,
    completed: 8,
    declined: 2,
    supplier_failed: 5,
    validation_failed: 1,
    unknown: 1,
  };
  const activeStep = activeByStage[stage] || 1;

  return (
    <div className="w-full bg-white px-6 py-4 border border-gray-200 rounded-xl shadow-sm hidden lg:flex flex-col justify-between items-center mt-4 gap-3">
      <div className="w-full flex justify-between  items-center">
        {steps.map((label, index) => {
          const stepNum = index + 1;
          const isActive = stepNum === activeStep;
          const isCompleted = stepNum < activeStep;

          return (
            <div
              key={label}
              className="flex-1 flex flex-col items-center relative"
            >
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center z-10 ${
                  isCompleted
                    ? "bg-primary1 text-white"
                    : isActive
                      ? "bg-yellow-400 text-white"
                      : "bg-gray-200 text-gray-500"
                }`}
              >
                {isCompleted ? (
                  <span className="text-lg font-semibold">✓</span>
                ) : isActive ? (
                  <LuClock className="text-lg text-white" />
                ) : (
                  <span className="text-base font-semibold">{stepNum}</span>
                )}
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`absolute left-1/2 top-5 h-[2px] w-full -translate-y-1/2 ${
                    isCompleted ? "bg-primary1" : "bg-gray-200"
                  }`}
                ></div>
              )}

              <div
                className={
                  "whitespace-nowrap text-xs mt-1 " +
                  (isActive ? "text-black" : "text-gray-400")
                }
              >
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RefundConfirmationRequestProgress;
